module.exports = __webpack_public_path__ + "static/media/E_01_FAIL.b9cad0e3.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/E_01_FAIL.mp3
// module id = 122
// module chunks = 0